/**
 * deckarts-upload-fix.js v2
 * Виправлена версія: правильний селектор Onhow widget,
 * file input знаходиться поза формою — додаємо hidden URL input до форми.
 */
(function () {
  'use strict';

  var CLOUD_NAME = 'dcaim4bm';
  var UPLOAD_PRESET = 'deckarts_upload';
  var UPLOAD_URL = 'https://api.cloudinary.com/v1_1/' + CLOUD_NAME + '/raw/upload';
  var PROP_NAME = 'properties[Upload File]';

  var isUploading = false;

  function getOnhowFileInput() {
    return document.querySelector('input.onhow-studio-upload-input');
  }

  function uploadToCloudinary(file) {
    var fd = new FormData();
    fd.append('file', file);
    fd.append('upload_preset', UPLOAD_PRESET);
    fd.append('folder', 'deckarts-orders');
    return fetch(UPLOAD_URL, { method: 'POST', body: fd })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (!data.secure_url) {
          throw new Error(data.error ? data.error.message : 'Upload failed');
        }
        return data.secure_url;
      });
  }

  function init() {
    document.addEventListener('click', function (e) {
      if (isUploading) return;

      var btn = e.target.closest('button[type="submit"]');
      if (!btn) return;

      var form = btn.closest('form[action*="/cart/add"]');
      if (!form) return;

      var fileInput = getOnhowFileInput();
      if (!fileInput || !fileInput.files || !fileInput.files[0]) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var file = fileInput.files[0];
      var originalHTML = btn.innerHTML;
      btn.disabled = true;
      btn.textContent = 'Uploading…';
      isUploading = true;

      uploadToCloudinary(file)
        .then(function (url) {
          var prev = form.querySelector('input[name="' + PROP_NAME + '"]');
          if (prev) prev.remove();

          var urlInput = document.createElement('input');
          urlInput.type = 'hidden';
          urlInput.name = PROP_NAME;
          urlInput.value = url;
          form.appendChild(urlInput);

          fileInput.value = '';

          btn.innerHTML = originalHTML;
          btn.disabled = false;
          isUploading = false;

          btn.click();
        })
        .catch(function (err) {
          console.error('[deckarts] upload error:', err);
          btn.innerHTML = originalHTML;
          btn.disabled = false;
          isUploading = false;
          alert('Помилка завантаження файлу. Спробуй ще раз або надішли файл на hello@deckarts.com');
        });

    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
